module.exports = __webpack_public_path__ + "assets/img/left-big-hover.f9706188.svg";